import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';

import { uploadFileToS3 } from '@/service/s3Service';
import organizationService from '@/service/organizationService';
import { getUrlLinkCorporationDetails, initCorporationAndListUser } from '@/component/rootOrganization/EditOrganizationHandler';
import { getTicketById } from '@/service/ticketService';

/**
 * Handle submit edit corporation
 * @param {*} API
 * @param {*} stateObj
 * @param {*} formData
 * @param {*} corporationDetail
 * @param {*} updator
 * @returns corporationDetail
 */
export const handleSubmitEditCorporation = async (
    API,
    stateObj,
    formData,
    corporationDetail,
    updator,
    setLincenseKey,
    setLicenseKeyDefault,
    lincenseKey,
    usingAIAuto,
    systemPrompt,
    chatGPTModel,
    knn,
    minScore,
    setSystemPromptDefault,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    setSystemPrompt,
    setInputSystemPrompt,
    interatorSystemPrompt,
    setInteratorSystemPrompt,
    setInteratorSystemPromptDefault,
    setInputInteratorSystemPrompt
) => {
    try {
        if (stateObj?.croppedImage?.image && stateObj?.logoFileName) {
            stateObj.croppedImage.name = stateObj.logoFileName;
        }

        const corporationSetting = {
            usingIpAddressRestrict: formData?.usingIpAddressRestrict,
            ipAddressRange: formData?.ipAddressRange
        }

        let editCorporationRequestDto = {
            id: corporationDetail.id,
            name: formData.corporationName,
            mail: formData.mailAdmin,
            owner: formData.selectedAdmin.id,
            tel: formData.telNumberCorporation ? formData.telNumberCorporation : '',
            usingChatAI: formData?.usingChatAI,
            updator: updator,
            usingAIAuto: usingAIAuto ? Constant.STATUS_SERVICE_PERMISSION.ON : Constant.STATUS_SERVICE_PERMISSION.OFF,
            systemPrompt: systemPrompt?.linkPrompt,
            interatorSystemPrompt: interatorSystemPrompt?.linkPrompt,
            corporationSetting: JSON.stringify(corporationSetting),
            chatGPTModel: chatGPTModel,
            knnValue: knn.value,
            minScore: minScore.value
        };

        if (stateObj.croppedImage) {
            let logo = {
                image: `${corporationDetail.organizationDomain}/logo/logo` + new Date().getTime(),
                name: stateObj.croppedImage.name
            }
            
            await uploadLogoS3(stateObj.croppedImage, logo.image + '/' + logo.name);
            editCorporationRequestDto.logo = JSON.stringify(logo);
        } else {
            editCorporationRequestDto.logo = JSON.stringify({});
        }

        editCorporationRequestDto.lincenseKeyValue = formData.lincenseKeyValue || '';

        let editOrganizationRequestBody = { editCorporationRequestDto: editCorporationRequestDto };

        let resEditOrganization = await organizationService.editOrganization(
            API,
            editOrganizationRequestBody
        );
        setSystemPromptDefault(systemPrompt);
        setInteratorSystemPromptDefault(interatorSystemPrompt);
        setChatGPTModelDefault(chatGPTModel);
        setKnnDefault(knn);
        setMinScoreDefault(minScore);
        setLicenseKeyDefault(lincenseKey.value);
        let limitValue = Utils.convertJSONDataToObject(resEditOrganization.limitValue)
        let corporationDetailResult = { 
            ...corporationDetail, 
            corporationSetting: resEditOrganization?.corporationSetting,
            logoFileName: resEditOrganization.logoFileName ? resEditOrganization.logoFileName : corporationDetail.logoFileName 
        };

        // create corporation detail result
        
        let corporationLogo = Utils.getCloudFrontUrlForCorporationLogo({
            type: Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE,
            image: resEditOrganization.image,
            corporationId: corporationDetail.organizationDomain,
            corporationDetail: corporationDetailResult
        });
        
        corporationDetailResult.corporationName = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            resEditOrganization.name
        );
        corporationDetailResult.logoFileName = resEditOrganization.logoFileName;
        corporationDetailResult.image = resEditOrganization.image;
        corporationDetailResult.name = resEditOrganization.name;
        corporationDetailResult.corporationLogo = corporationLogo;
        corporationDetailResult.limitValue = limitValue;
        corporationDetailResult.mail = editCorporationRequestDto.mail;
        corporationDetailResult.owner = editCorporationRequestDto.owner;

        return {
            isEditedSuccess: true,
            corporationDetail : corporationDetailResult
        };
    } catch (err) {
        console.log('err editCorp >>>', err)
        if(!Utils.isEmptyObject(err) && !Utils.isEmptyArray(err.errors[0])) {
            if (
                [
                    'ApiError==MSG_AI_LICENSE_KEY_REQUIRED',
                    'ApiError==MSG_AI_LICENSE_KEY_INVALID',
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setLincenseKey(prev => ({
                    ...prev,
                    error: I18n.get(`${errMsg.split("==")[1]}`)
                }))
            }
            if (
                [
                    'ApiError==MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN'
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setSystemPrompt(prev => ({
                    ...prev,
                    error: I18n.get(`${errMsg.split("==")[1]}`)
                }))
                setInputSystemPrompt(systemPrompt?.linkPrompt);
            }
            if (
                [
                    'ApiError==MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR'
                ].includes(err.errors[0].message)
            ) {
                const errMsg = err.errors[0].message;
                setInteratorSystemPrompt(prev => ({
                    ...prev,
                    error: I18n.get(`${errMsg.split("==")[1]}`)
                }))
                setInputInteratorSystemPrompt(interatorSystemPrompt?.linkPrompt);
            }

            return {
                isEditedSuccess: false,
                error: err.errors[0].message,
                corporationDetail
            };
        }
    }
};

const uploadLogoS3 = async (croppedImage, filePath) => {
    if (!croppedImage) return;
    if (croppedImage.file) {
        let fileUpload = { ...croppedImage };
        fileUpload.key = filePath;
        let uploadAvatar = await uploadFileToS3(filePath, fileUpload);
        if (!uploadAvatar) {
            return;
        }
    }
};

export const getInitCorporationAndListUser = async (argsAll) => {  
    try {
        argsAll.setIsLoading(true);

        const apiResponse = await initCorporationAndListUser(argsAll.corporationId);

        if (!apiResponse || Utils.isEmptyObject(apiResponse)) {
            return false;
        }
        if (apiResponse?.corporationData?.active === Constant.CORPORATION_ACTIVE.DELETED) {
            argsAll.closePanelTab({
                event: null,
                panelType: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
                panelId: argsAll.panelId,
                tabId: argsAll.tabId
            });
            return false;
        }
        if (!Utils.isEmptyArray(apiResponse.adminList)) {
            apiResponse.adminList = Utils.sortListByLabelDictionaryASC(
                apiResponse.adminList,
                'fullName'
            );
        }
        argsAll.setInitData(apiResponse);

        const checkAdminGuest = Utils.isGuestContractType(apiResponse.corporationData)
        argsAll.setIsAdminGuest(checkAdminGuest);

        argsAll.setAdminList(apiResponse.adminList);

        argsAll.setAdminName(apiResponse.ownerData.fullName);
        
        argsAll.setAdminMail(apiResponse.ownerData.mail);

        argsAll.setCorporationPhone(apiResponse.corporationData.tel);

        const getSubDomain = getUrlLinkCorporationDetails(apiResponse.corporationData);
        argsAll.setSubDomain(getSubDomain)

        argsAll.setUsingChatAI(
            apiResponse.corporationData.limitValue?.usingChatAI ? apiResponse.corporationData.limitValue.usingChatAI  === Constant.STATUS_SERVICE_PERMISSION.ON : false
        );

        argsAll.setUsingAIAuto(
            apiResponse.corporationData.limitValue?.usingAIAuto
                ? apiResponse.corporationData.limitValue.usingAIAuto ===
                      Constant.STATUS_SERVICE_PERMISSION.ON
                : false
        );

        const systemPromptDetail = apiResponse.corporationData.limitValue?.systemPrompt
            ? apiResponse.corporationData.limitValue?.systemPrompt
            : {
                  value: '',
                  error: '',
                  linkPrompt: ''
              };
        if (!Utils.isEmptyString(systemPromptDetail?.linkPrompt)) {
            const systemPromptId = await Utils.getTicketIdByShareLink(systemPromptDetail?.linkPrompt);
            const ticketDetail = await getTicketById(null, systemPromptId)
            const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId)
            if (
                (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                    !formStatusOfTicket?.active ||
                    ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                    ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
                !Utils.isEmptyObject(ticketDetail)
            ) {
                systemPromptDetail.error = I18n.get('MSG-CM-INVALID-LINK-PROMPT');
                systemPromptDetail.value = ''
            }
        }
        argsAll.setInputSystemPrompt(systemPromptDetail?.linkPrompt)
        argsAll.setSystemPrompt(systemPromptDetail);
        argsAll.setSystemPromptDefault(systemPromptDetail);

        const interatorSystemPromptDetail = apiResponse.corporationData.limitValue?.interatorSystemPrompt
            ? apiResponse.corporationData.limitValue?.interatorSystemPrompt
            : {
                  value: '',
                  error: '',
                  linkPrompt: ''
              };
        if (!Utils.isEmptyString(interatorSystemPromptDetail?.linkPrompt)) {
            const interatorSystemPromptId = interatorSystemPromptDetail?.linkPrompt
            ?.split('/')
            .pop();
            const ticketDetail = await getTicketById(null, interatorSystemPromptId);
            const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId);
            if (
                (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                    !formStatusOfTicket?.active ||
                    ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                    ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
                !Utils.isEmptyObject(ticketDetail)
            ) {
                interatorSystemPromptDetail.error = I18n.get('MSG-CM-INVALID-LINK-PROMPT');
                interatorSystemPromptDetail.value = '';
            }
        }
        argsAll.setInputInteratorSystemPrompt(interatorSystemPromptDetail?.linkPrompt)
        argsAll.setInteratorSystemPrompt(interatorSystemPromptDetail);
        argsAll.setInteratorSystemPromptDefault(interatorSystemPromptDetail);
        
        let dataSettingChatGPTModel = {
            chatGPTModel: apiResponse?.corporationData?.corporationSetting?.chatGPTModel
                ? apiResponse?.corporationData?.corporationSetting?.chatGPTModel
                : apiResponse?.corporationData?.limitValue.chatGPTModel,
            knnValue: apiResponse?.corporationData?.corporationSetting?.knnValue
                ? apiResponse?.corporationData?.corporationSetting?.knnValue
                : apiResponse?.corporationData?.limitValue.knnValue,
            minScore: apiResponse?.corporationData?.corporationSetting?.minScore
                ? apiResponse?.corporationData?.corporationSetting?.minScore
                : apiResponse?.corporationData?.limitValue.minScore
        };
        
        argsAll.setChatGPTModel(dataSettingChatGPTModel.chatGPTModel);
        argsAll.setChatGPTModelList(Constant.LIST_GPT_MODEL);
        argsAll.setKnn({
            value: dataSettingChatGPTModel.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
            error: ''
        })
        argsAll.setMinScore({
            value: dataSettingChatGPTModel.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
            error: ''
        })

        argsAll.setChatGPTModelDefault(dataSettingChatGPTModel.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
        argsAll.setKnnDefault({
            value: dataSettingChatGPTModel.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
            error: ''
        })
        argsAll.setMinScoreDefault({
            value: dataSettingChatGPTModel.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
            error: ''
        })
        
        argsAll.setImagePreview(argsAll.corporationDetailAtom.corporationLogo);
        argsAll.setLogoFileName(argsAll.corporationDetailAtom.logoFileName);
        argsAll.setOldLogoFileName(argsAll.corporationDetailAtom.logoFileName);
        
        argsAll.register('corporationName');
        argsAll.register('selectedAdmin');
        argsAll.register('mailAdmin');
        argsAll.register('telNumberCorporation');
        argsAll.register('usingChatAI');

        argsAll.setValue('corporationName', apiResponse.corporationData.name);
        argsAll.setValue('selectedAdmin', apiResponse.ownerData);
        argsAll.setValue('mailAdmin', apiResponse.ownerData.mail);
        argsAll.setValue('telNumberCorporation', apiResponse.corporationData.tel);
        argsAll.setValue('usingChatAI', apiResponse.corporationData.limitValue?.usingChatAI ? apiResponse.corporationData.limitValue?.usingChatAI : Constant.STATUS_SERVICE_PERMISSION.OFF);

        argsAll.register('lincenseKeyValue');
        argsAll.setValue('lincenseKeyValue', apiResponse?.corporationData?.limitValue?.lincenseKeyValue);

        argsAll.setLincenseKeyPermission(
            apiResponse.corporationData.limitValue?.lincenseKeyPermission === Constant.STATUS_SERVICE_PERMISSION.ON
        );

        argsAll.setLincenseKey({
            value: apiResponse?.corporationData?.limitValue?.lincenseKeyValue,
            error: apiResponse?.corporationData?.limitValue?.lincenseKeyValid
                ? I18n.get(`${apiResponse?.corporationData?.limitValue?.lincenseKeyValid}`)
                : ''
        });

        argsAll.setLicenseKeyDefault(apiResponse?.corporationData?.limitValue?.lincenseKeyValue);

        return true;

    } catch (e) {
        console.log('get initCorp error >>>', e);
        return e;
    }
}

export const onLogoFileChange = (event, setLogoFileName, setInputImage, setOpenCrop) => {
    const file = event.target.files[0];
    if (file) {
        setLogoFileName(file.name);
        Utils.readFileAsArrayBuffer(file).then(reader => {
            const buffer = Buffer.from(reader.result);
            const imgBase64 = buffer.toString('base64');
            setInputImage(`data:${file.type};base64,${imgBase64}`);
            setOpenCrop(true);
            event.target.value = '';
        });
    }
};

export const handleCancelTab = (
    isEdited,
    setIsShowPopUpCancel,
    errors,
    errorImage
) => {
    if (
        isEdited &&
        Utils.isEmptyObject(errors) &&
        Utils.isEmptyString(errorImage) 
    ) {
        setIsShowPopUpCancel(true);
    }
};

export const handleCloseTab = (
    panelId,
    tabId,
    panelList,
    closePanelTab,
    setIsShowPopUpCloseTab
) => {
    let currentPanelInfo = Utils.getPanelInfo(panelId, panelList);
    if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
    closePanelTab({
        event: null,
        panelType: currentPanelInfo.type,
        panelId: panelId,
        tabId: tabId
    });
    setIsShowPopUpCloseTab(false);
}